<!-- ========================================================= -->
<!-- SINGLE ENQUIRY PAGE BACKGROUND -->
<!-- ========================================================= -->

<section class="ecb-single-enquire-page">

  <div class="ecb-single-enquire-page-content">
    <span class="ecb-single-enquire-eyebrow">ECB TRAINING</span>
    <h1>Course Enquiry</h1>
    <p>
      Submit an enquiry for the selected training course and our team will contact you with the next available options.
    </p>
  </div>


  <!-- Loading / error area when a requested course cannot be opened -->
  <div class="ecb-single-enquire-status-card" *ngIf="bookingErrorMessage && !showCourseModal && !showParticipantModal">

    <div class="ecb-single-enquire-status-icon">
      <i class="bi bi-exclamation-circle"></i>
    </div>

    <h3>Unable to open course</h3>

    <p>
      {{ bookingErrorMessage }}
    </p>

    <button type="button" class="btn ecb-single-enquire-back-button" (click)="closeCourseDetails()">
      <i class="bi bi-arrow-left"></i>
      Back
    </button>

  </div>


  <!-- ========================================================= -->
  <!-- COURSE DETAILS MODAL -->
  <!-- ========================================================= -->

  <div class="ecb-course-details-modal-backdrop" *ngIf="showCourseModal" (click)="closeCourseDetails()">

    <div class="ecb-course-details-modal ecb-course-booking-modal" (click)="$event.stopPropagation()">


      <!-- Header -->
      <div class="ecb-course-booking-header">

        <div class="ecb-course-booking-header-title">

          <h2>
            {{ selectedCourseDetails?.courseCode }}
            -
            {{ selectedCourseDetails?.courseName }}
          </h2>

          <!-- <span class="ecb-course-booking-type-badge">
            {{ selectedCourseTypeLabel }}
          </span> -->

        </div>


        <div class="ecb-course-booking-header-actions">

          <button type="button" class="btn ecb-course-booking-main-button ecb-course-booking-header-button"
            (click)="openParticipantDetails()">

            <span>
              {{ primaryActionText }}
            </span>

            <i class="bi bi-arrow-right"></i>

          </button>


          <button type="button" class="ecb-course-details-close-button" (click)="closeCourseDetails()">

            <i class="bi bi-x-lg"></i>

          </button>

        </div>

      </div>


      <!-- Scroll only modal content -->
      <div class="ecb-course-booking-scroll-content">


        <!-- Success -->
        <div class="alert alert-success ecb-course-booking-message" *ngIf="bookingSuccessMessage">
          <i class="bi bi-check-circle-fill"></i>
          {{ bookingSuccessMessage }}
        </div>


        <!-- Description -->
        <div class="  ecb-x-details-rte-content" *ngIf="selectedCourseDetails?.description"
          [innerHtml]="selectedCourseDetails.description | safeHtml">

        </div>


        <!-- No calendar information strip -->
        <div class="ecb-course-booking-information-strip ecb-course-enquiry-information-strip" *ngIf="isDirectEnquiry">

          <div class="ecb-course-booking-strip-item">

            <div class="ecb-course-booking-strip-icon">
              <i class="bi bi-send"></i>
            </div>

            <div>
              <small>ENQUIRY TYPE</small>
              <strong>Course Enquiry</strong>
            </div>

          </div>


          <div class="ecb-course-booking-strip-divider"></div>


          <div class="ecb-course-booking-strip-item">

            <div class="ecb-course-booking-strip-icon">
              <i class="bi bi-calendar2-x"></i>
            </div>

            <div>
              <small>CALENDAR AVAILABILITY</small>
              <strong style="color:red">No active scheduled occurrence is currently available</strong>
            </div>

          </div>

        </div>


        <!-- Existing calendar strip kept for future/non-direct use -->
        <div class="ecb-course-booking-information-strip" *ngIf="!isDirectEnquiry">

          <div class="ecb-course-booking-strip-item">

            <div class="ecb-course-booking-strip-icon">
              <i class="bi bi-calendar-check"></i>
            </div>

            <div>
              <small>ASSESSMENT</small>
              <strong>Practical and Knowledge Assessment</strong>
            </div>

          </div>


          <div class="ecb-course-booking-strip-divider"></div>


          <div class="ecb-course-booking-strip-item">

            <div class="ecb-course-booking-strip-icon">
              <i class="bi bi-clock"></i>
            </div>

            <div>
              <small>COURSE DATES</small>
              <strong>
                {{ selectedCourseDetails?.startDate | date:'dd MMM yyyy' }}
                -
                {{ selectedCourseDetails?.endDate | date:'dd MMM yyyy' }}
              </strong>
            </div>

          </div>

        </div>


        <!-- Main Body -->
        <div class="row g-4 ecb-course-booking-content">


          <!-- LEFT -->
          <div class="col-12 col-lg-6">


            <div class="ecb-course-booking-detail-row">

              <span>Course Type</span>

              <strong>
                {{ selectedCourseTypeLabel }}
              </strong>

            </div>


            <div class="ecb-course-booking-detail-row">

              <span>Course Code</span>

              <strong>
                {{ selectedCourseDetails?.courseCode || '-' }}
              </strong>

            </div>


            <div class="ecb-course-booking-detail-row" *ngIf="selectedCourseType === 'VOC'">

              <span>Related UOC</span>

              <strong>
                {{ selectedParentUOCText }}
              </strong>

            </div>


            <div class="ecb-course-booking-detail-row" *ngIf="isDirectEnquiry">

              <span>Availability</span>

              <strong class="ecb-course-booking-enquiry-status">
                <i class="bi bi-info-circle"></i>
                Enquiry Required
              </strong>

            </div>


            <!-- Calendar details only when an occurrence exists -->
            <ng-container *ngIf="!isDirectEnquiry">

              <div class="ecb-course-booking-detail-row">
                <span>Registrations Close</span>
                <strong>{{ selectedCourseDetails?.registrationEndDate | date:'dd MMM yyyy' }}</strong>
              </div>

              <div class="ecb-course-booking-detail-row">
                <span>Course Dates</span>
                <strong>
                  {{ selectedCourseDetails?.startDate | date:'dd MMM yyyy' }}
                  to
                  {{ selectedCourseDetails?.endDate | date:'dd MMM yyyy' }}
                </strong>
              </div>

              <div class="ecb-course-booking-detail-row">
                <span>Vacancies</span>
                <strong class="ecb-course-booking-vacancies">
                  {{ selectedCourseDetails?.availableSeats }} Seats Available
                </strong>
              </div>

              <div class="ecb-course-booking-detail-row">
                <span>Location</span>
                <strong class="ecb-course-booking-location">
                  <i class="bi bi-geo-alt"></i>
                  {{ selectedCourseDetails?.location }}
                </strong>
              </div>

            </ng-container>


            <!-- Selection -->
            <div class="ecb-course-booking-selection-box">

              <h5>
                <i class="bi bi-clipboard2-check"></i>
                Your Selection
              </h5>


              <div class="ecb-course-booking-selection-row">

                <span>Requested Course</span>

                <strong>
                  {{ selectedCourseDetails?.courseCode }}
                  -
                  {{ selectedCourseDetails?.courseName }}
                </strong>

              </div>


              <div class="ecb-course-booking-selection-row" *ngIf="additionalUOCsOnly.length > 0">

                <span>
                  Additional UOC ({{ additionalUOCsOnly.length }})
                </span>

                <strong>
                  <ng-container *ngFor="let course of additionalUOCsOnly; let last = last">
                    {{ course.courseCode }}<span *ngIf="!last">, </span>
                  </ng-container>
                </strong>

              </div>


              <div class="ecb-course-booking-selection-row" *ngIf="additionalVOCsOnly.length > 0">

                <span>
                  Additional VOC ({{ additionalVOCsOnly.length }})
                </span>

                <strong>
                  <ng-container *ngFor="let voc of additionalVOCsOnly; let last = last">
                    {{ voc.vocCode }}<span *ngIf="!last">, </span>
                  </ng-container>
                </strong>

              </div>


              <div class="ecb-course-booking-selection-total">

                <div>
                  <i class="bi bi-collection"></i>
                  <span>Total Courses</span>
                  <strong>{{ totalSelectedCourses }}</strong>
                </div>

              </div>

            </div>

          </div>


          <!-- RIGHT -->
          <div class="col-12 col-lg-6">


            <!-- UOC -->
            <div class="ecb-course-booking-add-box">

              <h4>
                Add UOC Course(s)
              </h4>

              <p>
                Select one or more UOC courses to include with this enquiry.
              </p>


              <p-dropdown
                [(ngModel)]="selectedUOCId"
                name="selectedUOCId"
                [options]="availableUOCCourses"
                optionLabel="courseTitle"
                optionValue="id"
                [filter]="false"
                [showClear]="false"
                [scrollHeight]="'300px'"
                [loading]="dropdownLoading"
                [style]="{ width: '100%' }"
                    [autoZIndex]="true"
    [baseZIndex]="11000"
                appendTo="body"
                panelStyleClass="ecb-single-enquire-uoc-dropdown-panel"
                placeholder="Select UOC Course"
                (onShow)="onCourseDropdownOpened()"
                (onHide)="onCourseDropdownHidden()"
                (onChange)="addSelectedUOC()">

                <ng-template pTemplate="header">
                  <div class="p-2">
                    <input
                      type="search"
                      class="form-control"
                      placeholder="Search course code or title"
                      [value]="dropdownSearchText"
                      (input)="onDropdownSearch($any($event.target).value)">
                  </div>
                </ng-template>

                <ng-template pTemplate="selectedItem" let-course>
                  <span *ngIf="course">
                   {{ course.courseTitle }}
                  </span>
                </ng-template>

                <ng-template pTemplate="item" let-course>
                  <div class="ecb-web-course-option">
                
                    <span>{{ course.courseTitle }}</span>
                  </div>
                </ng-template>

                <ng-template pTemplate="footer">
                  <div class="p-2 text-center"
                    *ngIf="dropdownHasLoaded && dropdownUOCCourses.length < dropdownTotalRecords">
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-secondary"
                      [disabled]="dropdownLoading"
                      (click)="onCourseDropdownScroll()">
                      {{ dropdownLoading ? 'Loading...' : 'Load more courses' }}
                    </button>
                  </div>
                </ng-template>
              </p-dropdown>


              <div class="ecb-course-booking-added-item" *ngFor="let course of selectedAdditionalUOCs">

                <div>

                  <i class="bi bi-check-square-fill"></i>

                  <span>
                    <strong>{{ course.courseCode }}</strong>
                    -
                    {{ course.courseTitle }}

                    <small *ngIf="course.isPrimaryRequestedCourse" class="ecb-course-booking-selected-label">
                      Selected course
                    </small>
                  </span>

                </div>


                <button *ngIf="!course.isPrimaryRequestedCourse && !course.isPrimaryCalendarCourse" type="button"
                  (click)="removeSelectedUOC(course.id)">

                  <i class="bi bi-x"></i>

                </button>

              </div>

            </div>


            <!-- VOC -->
            <div class="ecb-course-booking-add-box">

              <h4>
                Add VOC Course(s)
                <small>(Optional)</small>
              </h4>

              <p>
                Select one or more VOC courses to include with this enquiry.
              </p>


              <select class="form-select" [(ngModel)]="selectedVOCId" name="selectedVOCId" (change)="addSelectedVOC()">

                <option [ngValue]="null">
                  Select VOC Course(s)
                </option>

                <option *ngFor="let voc of availableVOCCourses" [ngValue]="voc.id">

                  {{ voc.vocCode }}
                  -
                  {{ voc.vocName }}

                </option>

              </select>


              <div class="ecb-course-booking-added-item" *ngFor="let voc of selectedAdditionalVOCs">

                <div>

                  <i class="bi bi-check-square-fill"></i>

                  <span>
                    <strong>{{ voc.vocCode }}</strong>
                    -
                    {{ voc.vocName }}

                    <small *ngIf="voc.isPrimaryRequestedCourse" class="ecb-course-booking-selected-label">
                      Selected course
                    </small>
                  </span>

                </div>


                <button *ngIf="!voc.isPrimaryRequestedCourse" type="button" (click)="removeSelectedVOC(voc.id)">

                  <i class="bi bi-x"></i>

                </button>

              </div>

            </div>

          </div>

        </div>


        <!-- Footer -->
        <div class="ecb-course-booking-footer">

          <div class="ecb-course-booking-total">

            <span *ngIf="isDirectEnquiry">
              No current calendar occurrence is available for this course.
            </span>

            <small *ngIf="isDirectEnquiry">
              Send an enquiry and ECB Training will contact you regarding availability and booking options.
            </small>


            <ng-container *ngIf="!isDirectEnquiry">

              <div *ngIf="selectedCourseDetails?.totalAmount > 0 && !hasAdditionalCourses">
                <span>
                  Total
                  <small>(GST Inclusive)</small>
                </span>

                <strong>
                  A${{ selectedCourseDetails?.totalAmount | number:'1.2-2' }}
                </strong>
              </div>

              <div *ngIf="selectedCourseDetails?.totalAmount <= 0 || hasAdditionalCourses">
                <span>Please contact 1300 322 488</span>
              </div>

            </ng-container>

          </div>

        </div>

      </div>

    </div>

  </div>


  <!-- ========================================================= -->
  <!-- PARTICIPANT DETAILS MODAL -->
  <!-- ========================================================= -->

  <div class="ecb-participant-modal-backdrop" *ngIf="showParticipantModal">

    <div class="ecb-participant-modal">


      <!-- Header -->
      <div class="ecb-participant-modal-header">

        <div>

          <h3>
            Participant Details
          </h3>

          <p>
            Enter the participant details before sending your course enquiry.
          </p>

        </div>


        <button type="button" class="btn ecb-participant-back-button" (click)="backToCourseDetails()">

          <i class="bi bi-arrow-left"></i>
          Back

        </button>

      </div>


      <!-- Form -->
      <div class="ecb-participant-form">


        <div class="ecb-participant-form-row">

          <label for="participantGivenName">
            Given Name:
            <span>*</span>
          </label>

          <input id="participantGivenName" type="text" class="form-control" [maxlength]="250"
            [(ngModel)]="participantGivenName" name="participantGivenName">

        </div>


        <div class="ecb-participant-form-row">

          <label for="participantFamilyName">
            Family:
          </label>

          <input id="participantFamilyName" type="text" class="form-control" [maxlength]="250"
            [(ngModel)]="participantFamilyName" name="participantFamilyName">

        </div>


        <div class="ecb-participant-form-row">

          <label for="participantEmail">
            Email:
            <span>*</span>
          </label>

          <input id="participantEmail" type="email" class="form-control" maxlength="250" [(ngModel)]="participantEmail"
            name="participantEmail" #participantEmailCtrl="ngModel" appEmailValidator required>

        </div>

        <div class="ecb-participant-form-row">

          <label for="participantPhone">
            Contact Number:
            <span>*</span>
          </label>

          <input id="participantPhone" type="text" class="form-control" [(ngModel)]="participantPhone"
            name="participantPhone" #participantPhoneCtrl="ngModel" required appPhoneNumberValidation>

        </div>

      </div>


      <!-- Summary -->
      <div class="ecb-participant-summary">


        <div class="ecb-participant-summary-row">

          <span>Requested Course</span>

          <strong>
            {{ selectedCourseDetails?.courseCode }}
            -
            {{ selectedCourseDetails?.courseName }}
          </strong>

        </div>


        <div class="ecb-participant-summary-row">

          <span>Course Type</span>

          <strong>
            {{ selectedCourseTypeLabel }}
          </strong>

        </div>


        <div class="ecb-participant-summary-row" *ngIf="additionalUOCCount > 0">

          <span>Additional UOC</span>

          <strong>
            {{ additionalUOCCount }}
          </strong>

        </div>


        <div class="ecb-participant-summary-row" *ngIf="additionalVOCCount > 0">

          <span>Additional VOC</span>

          <strong>
            {{ additionalVOCCount }}
          </strong>

        </div>


        <div class="ecb-participant-summary-row ecb-participant-summary-total">

          <span>Booking Type</span>

          <strong>
            Course Enquiry
          </strong>

        </div>

      </div>


      <!-- Error -->
      <div class="alert alert-danger mt-3" *ngIf="participantFormError">
        {{ participantFormError }}
      </div>


      <div class="alert alert-danger mt-3"
        *ngIf="participantEmailCtrl.invalid && (participantEmailCtrl.dirty || participantEmailCtrl.touched)">

        <span *ngIf="participantEmailCtrl.errors?.['required']">
          Email is required.
        </span>

        <span *ngIf="participantEmailCtrl.errors?.['invalidEmail']">
          Please enter a valid email address.
        </span>



      </div>


      <!-- Footer -->
      <div class="ecb-participant-modal-footer">

        <button type="button" class="btn ecb-participant-cancel-button" (click)="closeParticipantModal()">

          Cancel

        </button>


        <button type="button" class="btn ecb-participant-enquiry-button" [disabled]="isSubmittingParticipant"
          (click)="submitParticipantDetails()">

          <i class="bi bi-send" *ngIf="!isSubmittingParticipant"></i>

          <span *ngIf="!isSubmittingParticipant">
            {{ participantActionText }}
          </span>

          <span *ngIf="isSubmittingParticipant">
            Processing...
          </span>

        </button>

      </div>

    </div>

  </div>

</section>


<!--Start Confirmation massage -->
<p-dialog [(visible)]="showEnquirySuccessPopup"   [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [autoZIndex]="true"
  [baseZIndex]="20000"
  appendTo="body"
  [style]="{ width: '460px', maxWidth: '95vw' }">
  <div class="text-center p-3">

    <i class="bi bi-check-circle-fill" style="
        font-size: 52px;
        color: #e35d1a;
      ">
    </i>

    <h3 style="
        margin-top: 18px;
        color: #56302b;
      ">
      Thank you for your enquiry!
    </h3>

    <p style="
        margin-top: 12px;
        color: #555;
        line-height: 1.6;
      ">

       Your course has been sent,

      <br><br>

      returned to our homepage.

    </p>

    <button type="button" class="btn ecb-x-corporate-save-button mt-3" (click)="closeEnquirySuccessPopup()">

      OK

    </button>

  </div>

</p-dialog>

<!--End Confirmation massage -->